import { render, staticRenderFns } from "./SliderDesktop.vue?vue&type=template&id=1d413153"
import script from "./SliderDesktop.vue?vue&type=script&lang=js"
export * from "./SliderDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RegisterButton: require('/opt/build/repo/components/register/Button.vue').default})
